"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SecureMap_inner_signatures;
var SignatureV1_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureV1 = exports.parse_signature = exports.SecureMap = exports.isSecureMap = exports.JsonValue = exports.implementsSignature = void 0;
const identification_1 = require("../identification");
const predicates_1 = require("../utils/predicates");
const error_1 = require("../error");
const variants_1 = require("../signature/variants");
const conversion_1 = require("../utils/conversion");
const jsrsasign_1 = require("jsrsasign");
const text_encoder_1 = require("../utils/text_encoder");
/**
 * Decorador para forzar la implementación de ambas interfaces en un objeto
 * @returns El constructor
 */
function implementsSignature() {
    return (constructor) => { constructor; };
}
exports.implementsSignature = implementsSignature;
/**
 * Funciones auxiliares al tipo JsonValue
 */
var JsonValue;
(function (JsonValue) {
    /**
     * Función para convertir un {@link JsonValue | JsonValue} en un "objeto nativo" de TS/JS.
     *
     * @param object
     * @returns
     */
    function into_obj(json_value) {
        if (json_value == undefined) {
            return undefined;
        }
        else if ((0, predicates_1.isString)(json_value)) {
            // Tenemos una cadena
            return json_value;
        }
        else if ((0, predicates_1.isNumber)(json_value)) {
            // Tenemos un número
            return json_value;
        }
        else if ((0, predicates_1.isBoolean)(json_value)) {
            // Tenemos un booleano
            return json_value;
        }
        else if ((0, predicates_1.isArray)(json_value)) {
            // Tenemos un array
            let array = new Array();
            for (let elem of json_value) {
                array.push(JsonValue.into_obj(elem));
            }
            return array;
        }
        else if (isSecureMap(json_value)) {
            let result = {};
            for (let [property_id, value] of json_value) {
                result[property_id] = into_obj(value);
            }
            // El mapa va de regreso
            return result;
        }
        else {
            throw "error imposible, todo es un objeto";
        }
    }
    JsonValue.into_obj = into_obj;
    /// Función que convierte un diccionario nativo de JS en un JsonValue
    function from_obj(object) {
        if (object === undefined) {
            throw "No se puede convertir undefined a un JsonValue";
        }
        else {
            if (typeof object === "string") {
                // Tenemos una cadena
                return object;
            }
            else if (typeof object === "number") {
                // Tenemos un número
                return object;
            }
            else if (typeof object === "boolean") {
                // Tenemos un booleano
                return object;
            }
            else if (object.findIndex != undefined) {
                // Tenemos un array
                let array = new Array();
                for (let elem of object) {
                    array.push(from_obj(elem));
                }
                return array;
            }
            else {
                // Vamos a pensar que a la fuerza es un objeto
                let map = new SecureMap();
                for (let [property_id, value] of Object.entries(object)) {
                    try {
                        map.set(property_id, from_obj(value));
                    }
                    catch (_e) {
                        // No se agrega el campo, pues simplemente no existe
                    }
                }
                return map;
            }
        }
    }
    JsonValue.from_obj = from_obj;
})(JsonValue = exports.JsonValue || (exports.JsonValue = {}));
/**
 * Función auxiliar para determinar si un objeto es un json seguro.
 *
 * @param candidate Candidato a probar
 * @returns Predicado de tipo {@link SecureMap | SecureMap}
 */
function isSecureMap(candidate) {
    //return (candidate as JsonableMap).serialize !== undefined;
    return typeof Map !== 'undefined' &&
        // gaurd for maps that were created in another window context
        Map.prototype.toString.call(candidate) === '[object Map]' ||
        // gaurd against toString being overridden
        candidate instanceof Map;
}
exports.isSecureMap = isSecureMap;
/**
 * Extensión de un `Map<string, {@link JsonValue | JsonValue}>` para soportar el firmado, de acuerdo al estandar del SAT.
 */
class SecureMap extends Map {
    constructor() {
        super(...arguments);
        _SecureMap_inner_signatures.set(this, void 0);
        // Verifies the signatures contained in the possible secure json object
        this.verify = () => {
            return new error_1.Error(error_1.ErrorCode.Unimplemented);
        };
        /**
         * Método de conversión a un objeto de js
         *
         * **Nota:** Se debe tener cuidado al utilizar este método, puesto que no se preservará necesariamente el orden de las llaves una vez que se construya el objeto
         *
         * @param object
         * @returns
         */
        this.into_obj = () => {
            let res = {};
            for (let [key, value] of this.entries()) {
                if (isSecureMap(value)) {
                    res[key] = value.into_obj();
                }
                else {
                    res[key] = value;
                }
            }
            return res;
        };
    }
    /**
     * Función auxiliar para serializar un {@link SecureMap | SecureMap}, es decir, convertirlo en una cadena.
     *
     * @returns La cadena que contiene la serialización del {@link SecureMap | SecureMap}
     */
    serialize() {
        //iterate through all the keys
        let result = '{';
        let count = 0;
        for (let [key, val] of this.entries()) {
            result += '"' + key + '":';
            if (val == null) {
                result += 'null';
            }
            else {
                if ((0, predicates_1.isArray)(val)) {
                    // Para cada entrada llamaremos serialize
                    result += "[" + val.map(entry => serialize_helper(entry)).join(",") + "]";
                }
                else {
                    result += serialize_helper(val);
                }
            }
            count += 1;
            if (count != this.size) {
                result += ',';
            }
        }
        result += '}';
        return result;
    }
    /**
     * Método de deserialización de un {@link SecureMap | SecureMap}.
     *
     * @param target Cadena fuente sobre la que se intentará realizar la deserialización.
     * @returns
     */
    static from_string(target) {
        let js = JSON.parse(target);
        let jm = new SecureMap();
        // Todo lo que parezca una llave va a hacer match
        let myRegex = /\"([^"]+)":/g;
        let foundKeys = target.match(myRegex);
        let keys = [];
        // Descartar las llaves que no se encuentran en el primer nivel
        foundKeys.forEach(function (key, idx, arr) {
            let k = key.split('"')[1];
            if (js.hasOwnProperty(k)) {
                keys.push(k);
            }
        });
        //Alimentamos el map. En caso de que el valor de una llave sea un objeto, verifica si, asu vez, se tiene que convertir en map
        keys.forEach(function (key, idx) {
            let vk = target.split('"' + key + '":')[1].split(keys[idx + 1])[0].slice(0, -1).replace(/,*$/, "");
            if (Object.prototype.toString.call(js[key]) == "[object Object]") {
                let mm = SecureMap.from_string(vk);
                jm.set(key, mm);
            }
            else if (Object.prototype.toString.call(js[key]) == "[object Array]") {
                let arr = vk.replace(/\[(.*?)\]/g, "$1").split(',');
                for (var i = 0; i < js[key].length; i++) {
                    if (Object.prototype.toString.call(js[key][i]) == "[object Object]") {
                        let mm = SecureMap.from_string(arr[i]);
                        js[key][i] = mm;
                    }
                }
                jm.set(key, js[key]);
            }
            else {
                jm.set(key, js[key]);
            }
        });
        // Ahora lidiamos con la posibilidad de contar con firmas
        __classPrivateFieldSet(jm, _SecureMap_inner_signatures, new Map(), "f");
        if ((0, predicates_1.isError)(jm)) {
            return jm;
        }
        else {
            let signatures = jm.get("$signatures");
            if (signatures != undefined) {
                if (isSecureMap(signatures)) {
                    for (let [key, val] of signatures) {
                        if (isSecureMap(val)) {
                            let sig = parse_signature(val);
                            if ((0, predicates_1.isError)(sig)) {
                                return sig;
                            }
                            else {
                                __classPrivateFieldGet(jm, _SecureMap_inner_signatures, "f").set(key, sig);
                            }
                        }
                        else {
                            //return {express: () => "La firma "+key+" no tiene formato válido"};
                            return new error_1.Error(error_1.ErrorCode.WrongStructure);
                        }
                    }
                }
                else {
                    //return {express: () => "Las firmas deben ser un diccionario"};
                    return new error_1.Error(error_1.ErrorCode.WrongStructure);
                }
            }
            return jm;
        }
    }
    /**
     * Método de "deserialización" desde un objeto de Typescript.
     *
     * **Nota:** Se debe tener cuidado al utilizar este método, puesto que no se preservará necesariamente el orden de las llaves que se muestran en el objeto
     *
     * @param object
     * @returns
     */
    static from_obj(object) {
        let jm = JsonValue.from_obj(object);
        if (isSecureMap(jm)) {
            return jm;
        }
        else {
            throw 'Not an instance of a map';
        }
    }
}
exports.SecureMap = SecureMap;
_SecureMap_inner_signatures = new WeakMap();
/**
 * Método auxiliar de serialización para todsos los elementos que no son un arreglo
 * @param arg
 * @returns
 */
function serialize_helper(arg) {
    if (isSecureMap(arg)) {
        // We just call the serialize function here
        return arg.serialize();
    }
    else {
        if ((0, predicates_1.isString)(arg)) {
            return '"' + escaped(arg) + '"';
        }
        else {
            if ((0, predicates_1.isNumber)(arg)) {
                return String(arg);
            }
            else {
                // Sólo puede ser un booleano
                return (arg ? 'true' : 'false');
            }
        }
    }
}
// Función para escapar una cadena durante el serializado
function escaped(val) {
    return val.replace(/\n/g, '\\n').replace(/\"/g, '\\"').replace(/\'/g, "\\'");
}
/********************************************
 * Implementación de las versiones de firma *
 ********************************************/
/**
 * Intenta "deserializar" un mapa seguro a una firma.
 *
 * @returns La firma, o en su caso, un error
 */
function parse_signature(secure_map) {
    let res = SignatureV1.from_secure_map(secure_map);
    if (!(0, predicates_1.isError)(res)) {
        return res;
    }
    return new error_1.Error(error_1.ErrorCode.WrongStructure, "secure_map != SignatureV1");
}
exports.parse_signature = parse_signature;
let $TextEncoder = (0, text_encoder_1.text_encoder)();
let SignatureV1 = SignatureV1_1 = class SignatureV1 extends SecureMap {
    //new(): Signature<identification>;
    // Due to typescript limitation, the passed secret has a type that might not match x509certificate
    static create(args) {
        let sig = new SignatureV1_1();
        sig.inner_version = "1.0.0-alpha.1";
        if (args.custom_data == undefined) {
            args.custom_data = null;
        }
        sig.inner_custom_data = args.custom_data;
        sig.inner_method = variants_1.SignatureMethod.SHA256withRSA;
        sig.inner_encoding = variants_1.SignatureEncoding.Base64;
        let signatures = args.content.get("$signatures");
        if (signatures != undefined) {
            args.content.delete("$signatures");
        }
        let encoder = $TextEncoder; //new TextEncoder();
        // The text needs to be treated as UTF-8 string
        let bytes = encoder.encode(args.content.serialize());
        let signature_bytes = args.identification.sign(bytes, args.secret);
        if ((0, predicates_1.isError)(signature_bytes)) {
            return signature_bytes;
        }
        let signature = (0, conversion_1.bytes2Base64)(signature_bytes);
        sig.inner_signature = signature;
        sig.inner_identification = args.identification;
        // Now the actual map treatment
        sig.set("version", sig.inner_version);
        sig.set("custom_data", sig.inner_custom_data);
        sig.set("method", sig.inner_method);
        sig.set("encoding", sig.inner_encoding);
        sig.set("signature", sig.inner_signature);
        sig.set("identification", sig.inner_identification.to_string());
        // If the signature is in place, we add it to the thingy
        if (args.in_place != undefined && args.in_place) {
            if (signatures == undefined) {
                let signatures = new SecureMap();
                signatures.set(args.identification.get_unique_id(), sig);
                args.content.set("$signatures", signatures);
            }
            else {
                if (isSecureMap(signatures)) {
                    signatures.set(args.identification.get_unique_id(), sig);
                }
                else {
                    return new error_1.Error(error_1.ErrorCode.WrongSignaturesStructure);
                }
            }
        }
        else {
            if (signatures != undefined) {
                args.content.set("$signatures", signatures);
            }
        }
        return sig;
    }
    // TODO: quitar este método
    static create_ayuda_microsoft(content, identification, secret, method, encoding, custom_data, in_place) {
        let sig = new SignatureV1_1();
        sig.inner_version = "1.0.0-alpha.1";
        if (custom_data == undefined) {
            custom_data = null;
        }
        sig.inner_custom_data = custom_data;
        if (method == undefined) {
            sig.inner_method = variants_1.SignatureMethod.SHA256withRSA;
        }
        else {
            sig.inner_method = method;
        }
        if (encoding == undefined) {
            sig.inner_encoding = variants_1.SignatureEncoding.Base64;
        }
        else {
            sig.inner_encoding = encoding;
        }
        console.log("El JSON original, \"canonizado\" es el siguiente:");
        console.log(content.serialize() + "\n");
        console.log("Ahora, lo que se hace es quitar el campo de firma (si está presente)");
        let signatures = content.get("$signatures");
        if (signatures != undefined) {
            content.delete("$signatures");
        }
        console.log("El nuevo json en forma canónica, es el siguiente:");
        console.log(content.serialize() + "\n");
        let encoder = $TextEncoder; //new TextEncoder();
        // The text needs to be treated as UTF-8 string
        let bytes = encoder.encode(content.serialize());
        console.log("De fondo, codificamos la cadena estrictamente como UTF-8 (js usa UTF-16), lo cual da la siguiente secuencia de bytes:");
        console.log(bytes);
        console.log("\n");
        console.log("A esos bytes se les calculará el Sha256, que debe verse así:");
        let tempa = (0, conversion_1.bytes2hex)(bytes);
        let dig = new jsrsasign_1.KJUR.crypto.MessageDigest({ alg: "sha256", prov: "sjcl" });
        let res_hex = dig.digestHex(tempa);
        console.log(res_hex + "\n");
        console.log("Y de aquí siguen los dos pasos del Sha256WithRsa, PKCSV1.5 (padding y exponenciar)");
        let signature_bytes = identification.sign(bytes, secret);
        if ((0, predicates_1.isError)(signature_bytes)) {
            return signature_bytes;
        }
        if (sig.inner_encoding == variants_1.SignatureEncoding.Base64) {
            let signature = (0, conversion_1.bytes2Base64)(signature_bytes);
            sig.inner_signature = signature;
        }
        else {
            let signature = (0, conversion_1.bytes2hex)(signature_bytes);
            sig.inner_signature = signature;
        }
        sig.inner_identification = identification;
        // Now the actual map treatment
        sig.set("version", sig.inner_version);
        sig.set("custom_data", sig.inner_custom_data);
        sig.set("method", sig.inner_method);
        sig.set("encoding", sig.inner_encoding);
        sig.set("signature", sig.inner_signature);
        sig.set("identification", sig.inner_identification.to_string());
        // If the signature is in place, we add it to the thingy
        if (in_place != undefined && in_place) {
            if (signatures == undefined) {
                let signatures = new SecureMap();
                signatures.set(identification.get_unique_id(), sig);
                content.set("$signatures", signatures);
            }
            else {
                if (isSecureMap(signatures)) {
                    signatures.set(identification.get_unique_id(), sig);
                }
                else {
                    return new error_1.Error(error_1.ErrorCode.WrongSignaturesStructure);
                }
            }
        }
        else {
            if (signatures != undefined) {
                content.set("$signatures", signatures);
            }
        }
        return sig;
    }
    /// Creates a signature from a jsonable map
    static from_secure_map(source) {
        let sv1 = new SignatureV1_1();
        let version = source.get("version");
        let custom_data = source.get("custom_data");
        let method = source.get("method");
        let encoding = source.get("encoding");
        let signature = source.get("signature");
        let identification = source.get("identification");
        if (version == undefined || method == undefined || encoding == undefined || signature == undefined || identification == undefined) {
            return new error_1.Error(error_1.ErrorCode.MissingFields);
        }
        // Validación de versión
        if ((0, predicates_1.isString)(version)) {
            if (version != "1.0.0-alpha.1") {
                return new error_1.Error(error_1.ErrorCode.UnsupportedVersion);
            }
            sv1.set("version", version);
            sv1.inner_version = version;
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(version) != string");
        }
        // Validación de la información "custom"
        if (custom_data != undefined) {
            if (isSecureMap(custom_data)) {
                sv1.set("custom_data", custom_data);
            }
            else {
                return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(custom_data) != map");
            }
        }
        // Validación del método
        if ((0, predicates_1.isString)(method)) {
            sv1.set("method", method);
            if (Object.values(variants_1.SignatureMethod).includes(method)) {
                sv1.inner_method = method;
            }
            else {
                return new error_1.Error(error_1.ErrorCode.InvalidValue, `"method" not in ${Object.values(variants_1.SignatureMethod)}`);
            }
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(method) != string");
        }
        // Validación del encoding
        if ((0, predicates_1.isString)(encoding)) {
            sv1.set("encoding", encoding);
            if (Object.keys(variants_1.SignatureEncoding).includes(encoding)) {
                sv1.inner_encoding = encoding;
            }
            else {
                return new error_1.Error(error_1.ErrorCode.InvalidValue, `"method" not in ${Object.values(variants_1.SignatureEncoding)}`);
            }
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(encoding) != string");
        }
        // Validación de la "firma"
        if ((0, predicates_1.isString)(signature)) {
            sv1.set("signature", signature);
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(signature) != string");
        }
        // Validación de la identificación
        if ((0, predicates_1.isString)(identification)) {
            sv1.set("identification", identification);
            let x_cert = identification_1.X509Certificate.from_string(identification);
            if ((0, predicates_1.isError)(x_cert)) {
                return x_cert;
            }
            sv1.inner_identification = x_cert;
        }
        else {
            return new error_1.Error(error_1.ErrorCode.WrongType, "typeof(identification) != string");
        }
        return sv1;
    }
    // creates a signature from cero
    static from_value(source) {
        return new error_1.Error(error_1.ErrorCode.Unimplemented);
    }
    /// In case one needs the current static version
    static get_static_version() {
        return "1.0.0-alpha.1";
    }
    /// Indicates if a given version is supported for an implementation
    static is_compatible(version) {
        return version == "1.0.0-alpha.1";
    }
    /**
     * Entrega la versión de la instancia de firma que llama al método.
     *
     * @returns Una cadena que representa la versión
     */
    get_version() {
        return "1.0.0-alpha.1";
    }
    /**
     * Entrega la información personalizada (en caso de existir) de la instancia de firma que llama al método.
     *
     * @returns La estructura de información personalizada, en caso de existir.
     */
    get_custom_data() {
        return this.inner_custom_data;
    }
    /**
     * Entrega la identificación de fondo que se utilizó para generar la firma.
     *
     * @returns La identificación con la que se realizó la firma
     */
    get_identification() {
        return new identification_1.IdentificationVariant(this.inner_identification);
    }
    verify_signature(message) {
        return new error_1.Error(error_1.ErrorCode.Unimplemented);
    }
};
SignatureV1 = SignatureV1_1 = __decorate([
    implementsSignature()
], SignatureV1);
exports.SignatureV1 = SignatureV1;
//# sourceMappingURL=secure_map.js.map